/* ===========================================================
   AREON — Mallikivien korivahti v2 (Nordstone)
   =========================================================== */
(function () {
  'use strict';

  var CFG = window.areonSampleCartConfig || {};
  var S = window.areonSampleStrings || {};
  var MAX = parseInt(CFG.max, 10) || 2;
  var VARIANT = (CFG.variantName || 'mallikivi').toLowerCase();
  var SAMPLE_PROP = '_sample';
  var MSG_LIMIT = (S.limitToast || 'Voit tilata enintään %MAX% mallikiveä. Poista ylimääräiset korista.').replace('%MAX%', MAX);
  var MSG_ALREADY = S.alreadyAdded || 'Tämä mallikivi on jo korissasi.';
  var MSG_FULL = (S.checkoutBlocked || S.cartFull || 'Sinulla on jo %MAX% mallikiveä korissa.').replace('%MAX%', MAX);

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);

  function getCart() {
    return origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isSample(item) {
    var p = item.properties || {};
    if (p[SAMPLE_PROP] === 'true') return true;
    var vt = (item.variant_title || '').toLowerCase();
    return vt.indexOf(VARIANT) !== -1;
  }

  function countSamples(cart) {
    return cart.items.reduce(function (n, item) {
      return isSample(item) ? n + item.quantity : n;
    }, 0);
  }

  /* ===========================================================
     1) ADD-VAHTI — cart/add -kutsujen sieppaus
     =========================================================== */
  var productCache = {};

  function currentProductVariantTitle(variantId) {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return Promise.resolve(null);
    var handle = m[1];
    var pr = productCache[handle]
      ? Promise.resolve(productCache[handle])
      : origFetch(root + 'products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) { productCache[handle] = p; return p; })
          .catch(function () { return null; });
    return pr.then(function (p) {
      if (!p || !p.variants) return null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === variantId) return p.variants[i].title || '';
      }
      return null;
    });
  }

  function parseAddBody(init) {
    var out = { items: [], form: null };
    if (!init || !init.body) return out;
    var body = init.body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      out.form = body;
      var id = parseInt(body.get('id'), 10);
      if (id) out.items.push({ id: id, quantity: parseInt(body.get('quantity') || '1', 10) || 1, properties: null });
    } else if (typeof body === 'string') {
      try {
        var j = JSON.parse(body);
        if (j.items && j.items.length) {
          j.items.forEach(function (it) {
            out.items.push({ id: parseInt(it.id, 10), quantity: it.quantity || 1, properties: it.properties || null });
          });
        } else if (j.id) {
          out.items.push({ id: parseInt(j.id, 10), quantity: j.quantity || 1, properties: j.properties || null });
        }
      } catch (e) { /* ei-JSON body — ohitetaan */ }
    }
    return out;
  }

  function itemIsSampleAdd(it) {
    var p = it.properties || {};
    if (p[SAMPLE_PROP] === 'true') return Promise.resolve(true);
    return currentProductVariantTitle(it.id).then(function (title) {
      return title ? title.toLowerCase().indexOf(VARIANT) !== -1 : false;
    });
  }

  function blockedResponse(msg) {
    var body = JSON.stringify({ status: 422, message: 'Cart Error', description: msg });
    return new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  function guardAdd(input, init) {
    var parsed = parseAddBody(init);
    if (!parsed.items.length) return origFetch(input, init);

    return Promise.all(parsed.items.map(itemIsSampleAdd)).then(function (flags) {
      var addingSample = false;
      for (var i = 0; i < flags.length; i++) { if (flags[i]) addingSample = true; }
      if (!addingSample) return origFetch(input, init);

      return getCart().then(function (cart) {
        var count = countSamples(cart);

        // Onko sama kivi jo korissa? (1 per kivi)
        var duplicate = parsed.items.some(function (it, i) {
          if (!flags[i]) return false;
          return cart.items.some(function (ci) {
            return ci.variant_id === it.id && isSample(ci);
          });
        });
        if (duplicate) return blockedResponse(MSG_ALREADY);
        if (count >= MAX) return blockedResponse(MSG_LIMIT);

        // Pakota mallikivilisäyksen määrä 1:een
        if (parsed.form) {
          parsed.form.set('quantity', '1');
        } else if (typeof init.body === 'string') {
          try {
            var j = JSON.parse(init.body);
            if (j.items) {
              j.items.forEach(function (it, i) { if (flags[i]) it.quantity = 1; });
            } else if (j.id) {
              j.quantity = 1;
            }
            init.body = JSON.stringify(j);
          } catch (e) { /* ignore */ }
        }
        return origFetch(input, init);
      });
    });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      if (url.indexOf('cart/add') !== -1) {
        return guardAdd(input, init || {});
      }
    } catch (e) { /* fallback alle */ }
    return origFetch(input, init);
  };

  /* ===========================================================
     3) KASSAVAHTI — napit + viesti
     =========================================================== */
  var notice = null;

  function checkoutButtons() {
    return document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], #checkout'
    );
  }

  function visibleCheckoutAnchor() {
    var sel = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], #checkout, [name="checkout"]';
    var btns = document.querySelectorAll(sel);
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].offsetParent !== null) return btns[i];
    }
    return btns.length ? btns[0] : null;
  }

  function noticeHost() {
    // Sijoita viesti NÄKYVÄÄN korialueeseen (kassanappi voi olla sticky/form-rakenteessa
    // joka heittää viestin ruudun ulkopuolelle, joten se on vasta viimeinen vara).
    var candidates = [
      '.cart__footer', '#main-cart-footer', '.cart__ctas', '.cart__blocks',
      'cart-items', '.cart-items', 'form[action*="/cart"]', '.cart', '#cart', 'main'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.offsetParent !== null) return { node: el, mode: 'prepend' };
    }
    // Viimeinen vara: kassanapin viereen
    var anchor = visibleCheckoutAnchor();
    if (anchor && anchor.parentNode) return { node: anchor, mode: 'before' };
    return null;
  }

  function ensureNotice() {
    if (notice && document.contains(notice)) return notice;
    var host = noticeHost();
    if (!host) return null;
    notice = document.createElement('p');
    notice.className = 'areon-sample-cart__notice';
    notice.style.cssText =
      'font-size:1.4rem;line-height:1.5;margin:0 0 1.6rem;padding:1rem 1.4rem;' +
      'border:0.1rem solid currentColor;opacity:0.9;position:relative;z-index:2;';
    if (host.mode === 'before') {
      host.node.parentNode.insertBefore(notice, host.node);
    } else if (host.mode === 'prepend') {
      host.node.insertBefore(notice, host.node.firstChild);
    } else {
      host.node.appendChild(notice);
    }
    return notice;
  }

  function updateUI(block, showNotice) {
    checkoutButtons().forEach(function (btn) {
      if (block) {
        btn.setAttribute('data-areon-blocked', '1');
        if ('disabled' in btn) btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '0.4';
        btn.style.pointerEvents = 'none';
      } else if (btn.hasAttribute('data-areon-blocked')) {
        btn.removeAttribute('data-areon-blocked');
        if ('disabled' in btn) btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      }
    });

    if (showNotice) {
      var n = ensureNotice();
      if (n) {
        n.textContent = block ? MSG_LIMIT : MSG_FULL;
        n.style.display = '';
      }
    } else if (notice && document.contains(notice)) {
      notice.style.display = 'none';
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-areon-blocked]');
    if (t) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ===========================================================
     2) MÄÄRÄVAHTI + valvontasilmukka
     =========================================================== */
  function setLineQty(line, qty) {
    return origFetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    });
  }

  var busy = false;

  function enforce() {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) {
        var fixes = [];       // rivit joiden määrä > 1 (sama kivi liikaa)
        var sampleCount = 0;  // montako ERI mallikiveä (riviä)
        cart.items.forEach(function (item, idx) {
          if (isSample(item)) {
            sampleCount++;
            if (item.quantity > 1) fixes.push(idx + 1);
          }
        });

        // 1) Pudota jokainen mallikivirivi takaisin 1:een (1 per kivi)
        if (fixes.length > 0) {
          var chain = Promise.resolve();
          fixes.forEach(function (line) {
            chain = chain.then(function () { return setLineQty(line, 1); });
          });
          return chain.then(function () {
            window.location.reload();
            return null;
          });
        }

        // 2) Kassa auki normaalisti. Turvaverkko: blokkaa vain jos jotenkin yli MAX.
        //    Ei pysyvää korisivun viestiä — esto+viesti tulee vain kolmatta lisättäessä (ADD-vahti).
        updateUI(sampleCount > MAX, false);
        return null;
      })
      .catch(function () { /* hiljainen */ })
      .then(function () { busy = false; });
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function boot() {
    enforce();
    var target =
      document.getElementById('main-cart-items') ||
      document.querySelector('cart-items, cart-drawer, form[action*="/cart"]') ||
      document.body;
    var mo = new MutationObserver(debounce(enforce, 400));
    mo.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
